import { ClinicColumns } from './components/ClinicColumns';
import { useGetClinics } from '@/services/queries/clinic';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CircleFadingPlus } from 'lucide-react';
import { PageTitle, DataTable, Button, SearchInput } from '@/components';

const Clinics = () => {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [page, setPage] = useState(Number(searchParams.get('page')) || 1);

	const { data } = useGetClinics({
		page,
		limit: Number(searchParams.get('limit')) || 5,
		status: null,
	});

	useEffect(() => {
		const params = new URLSearchParams(searchParams);
		if (!params.get('page')) params.set('page', '1');
		if (!params.get('limit')) params.set('limit', '5');
		setSearchParams(params, { replace: true });
	}, []);

	const handlePageChange = (newPage: number) => {
		const newParams = new URLSearchParams(searchParams);
		newParams.set('page', String(newPage));
		setSearchParams(newParams, { replace: true });
		setPage(newPage);
	};

	const handleEdit = (clinic: Clinics.Clinic) => {
		navigate(`/admin/clinicas/editar/${clinic.id}`, { replace: true });
	};

	return (
		<section className="animate-fade-in space-y-6 px-4 py-6">
			<div className="space-y-1">
				<PageTitle text="Clínicas" />
				<p className="text-sm text-stone-400">
					Gerencie as clínicas parceiras cadastradas.
				</p>
			</div>
			<div className="flex flex-col-reverse gap-3 sm:flex-row sm:items-center sm:justify-between">
				<div className="w-full sm:max-w-md">
					<SearchInput
						placeholder="Pesquisar por nome..."
						className="bg-inherit"
					/>
				</div>
				<Button
					className="w-full rounded-full bg-black px-6 py-2.5 font-bold shadow-md hover:bg-neutral-800 sm:w-auto"
					startIcon={<CircleFadingPlus className="w-4 text-light" />}
					text="Nova clínica"
					onClick={() => navigate('/admin/clinicas/criar')}
				/>
			</div>
			{data && (
				<DataTable
					columns={ClinicColumns({
						onEdit: handleEdit,
					})}
					data={data.data}
					page={page}
					limit={5}
					totalItems={data.total}
					onPageChange={handlePageChange}
				/>
			)}
		</section>
	);
};

export { Clinics };
